import request from './index.js'

// 初始化默认设置
export const initDefaultSettings = () => request.post('/admin/settings/init')

// ========== 微信配置 ==========
export const getWechatConfig = () => request.get('/admin/settings/wechat/config')
export const saveWechatConfig = (data) => request.post('/admin/settings/wechat/config', data)

// ========== 抽成规则配置 ==========
export const getCommissionConfig = () => request.get('/admin/settings/commission/config')
export const saveCommissionConfig = (data) => request.post('/admin/settings/commission/config', data)
export const calculateExample = (data) => request.post('/admin/settings/commission/calculate', data)

// ========== 地图配置 ==========
export const getMapConfig = () => request.get('/admin/settings/map/config')
export const saveMapConfig = (data) => request.post('/admin/settings/map/config', data)

// ========== 短信配置 ==========
export const getSmsConfig = () => request.get('/admin/settings/sms/config')
export const saveSmsConfig = (data) => request.post('/admin/settings/sms/config', data)

// ========== 电子签配置 ==========
export const getEsignConfig = () => request.get('/admin/settings/esign/config')
export const saveEsignConfig = (data) => request.post('/admin/settings/esign/config', data)

// ========== 邮件配置 ==========
export const getEmailConfig = () => request.get('/admin/settings/email/config')
export const saveEmailConfig = (data) => request.post('/admin/settings/email/config', data)

// ========== 支付配置 V4.0 ==========
export const getPaymentConfig = () => request.get('/admin/settings/payment/config')
export const savePaymentConfig = (data) => request.post('/admin/settings/payment/config', data)

// ========== 通用设置保存 ==========
export const saveSetting = (key, value, type, description) => 
  request.post('/admin/settings/single', { key, value, type, description })

export default {
  initDefaultSettings,
  getWechatConfig,
  saveWechatConfig,
  getCommissionConfig,
  saveCommissionConfig,
  calculateExample,
  getMapConfig,
  saveMapConfig,
  getSmsConfig,
  saveSmsConfig,
  getEsignConfig,
  saveEsignConfig,
  getEmailConfig,
  saveEmailConfig,
  getPaymentConfig,
  savePaymentConfig,
  saveSetting
}
